import { apiPost } from "../baseApi";
import { setTag } from "service/mapper";

export const updateUsers = async (data) => {
  try {
    const response = await apiPost("_bulkTag", data);
    return { ...response, data: setTag(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
